import ClickOutside from "vue-click-outside";

export default {
  directives: {
    ClickOutside,
  },

  data() {
    return {
      is_dropdown_show: false,
    };
  },

  computed: {
    getDropdownLinkClass() {
      return { "gw-headline__dropdown_opened": this.is_dropdown_show };
    },
  },

  methods: {
    showDropdown() {
      this.is_dropdown_show = true;
    },

    closeDropdown() {
      this.is_dropdown_show = false;
    },

    toggleDropdown() {
      this.is_dropdown_show = !this.is_dropdown_show;
    },
  },
};
